export default "__VITE_ASSET__dc052f02__"